<div>
    <h1>Bereken hier je voorstel</h1>
    
    <p>Hoe ziet uw situatie er uit? Selecteer hieronder wat voor jouw van toepassing is.</p>
    
    <div class="row mt-8">
        <div class="xl:col-3 lg:col-3 col-12">
            <p-button [fluid]="true" [routerLink]="['/price-calculation', 'step-2']">Doorgaan als particulier</p-button>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
        </div>
    </div>
    <div class="row mb-8">
        <div class="xl:col-3 lg:col-3 col-12">
            <p-button [fluid]="true" [outlined]="true" [routerLink]="['/contact']">Simulatie als zakelijke (<100MWh) of zakelijk grootverbruiker (>100MWh)</p-button>
        </div>
        <div class="xl:col-9 lg:col-9 col-12">
        </div>
    </div>
</div>